"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEnumType = getEnumType;
exports.getInterfaceLogList = getInterfaceLogList;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
function getEnumType() {
  return (0, _requestPIM.default)({
    url: '/xyInterfaceLog/getEnumType',
    method: 'get'
  });
}
function getInterfaceLogList(params) {
  return (0, _requestPIM.default)({
    url: '/xyInterfaceLog/page',
    method: 'get',
    params: params
  });
}